"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTabs = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const FormTab_1 = require("./FormTabs/FormTab");
const Grid_1 = require("../Grid");
const Wrap = (0, app_1.styled)(Grid_1.Grid) `
  width: 100%;
`;
function FormTabs({ tabs, className }) {
    const columns = (0, react_1.useMemo)(() => `repeat(${tabs.length}, minmax(0,1fr))`, [tabs.length]);
    return ((0, jsx_runtime_1.jsx)(Wrap, Object.assign({ className: className, templateColumns: columns }, { children: tabs.map((tab, idx) => ((0, jsx_runtime_1.jsx)(FormTab_1.FormTab, Object.assign({ page: idx + 1 }, tab), tab.title))) })));
}
exports.FormTabs = FormTabs;
